export function onRowsSelected(grid, callback) {
	if (callback) {
		grid.bind('custom:rowsSelected', ({ ids, items }) => {
			callback(ids, items);
		});
	}
}
